import * as React from 'react';
import 'fontsource-roboto';
import '../app.css';
import {
  Menu, MenuItem,
} from '@material-ui/core';

interface BoxActionMenuProps {
  boxId: string;
  anchorEl: HTMLElement;
  handleMarkDamaged: (id: string) => void;
  handleDelete: (id: string) => void;
  handleClose: () => void;
}

const BoxActionMenu: React.FC<BoxActionMenuProps> = (
  {
    boxId, anchorEl, handleMarkDamaged, handleDelete, handleClose,
  },
) => (
  <Menu
    anchorEl={anchorEl}
    keepMounted
    open
    onClose={handleClose}
    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
  >
    <MenuItem id="mark-box-as-damaged-button" onClick={() => handleMarkDamaged(boxId)}>{'Mark box as damaged'}</MenuItem>
    <MenuItem id="delete-box-button" onClick={() => handleDelete(boxId)}>{'Delete box'}</MenuItem>
  </Menu>
);

export default BoxActionMenu;
